<p-card
    class="viator-card cursor-pointer h-full"
    [styleClass]="'p-card-content-p-0 p-card-title-mb-0 h-full flex flex-column overflow-hidden border-1 surface-border shadow-none hover:shadow-2 ' + cardStyleClass"
    tabindex="0"
    role="button"
    [attr.aria-label]="experience.title"
    (click)="selected.emit(experience)"
    (keydown.enter)="selected.emit(experience)"
    (keydown.space)="$event.preventDefault(); selected.emit(experience)"
>
    <ng-template pTemplate="header">
        <img
            *ngIf="experience.imageUrl; else imagePlaceholder"
            [src]="experience.imageUrl"
            [alt]="experience.title"
            loading="lazy"
            class="block w-full h-12rem"
            style="object-fit: cover"
        />
        <ng-template #imagePlaceholder>
            <div class="w-full h-12rem surface-200"></div>
        </ng-template>
    </ng-template>

    <ng-template pTemplate="title">
        <div *ngIf="experience.rating !== null" class="flex gap-1 align-items-center mb-2">
            <i class="ph-fill ph-star text-teal-500 text-sm" aria-hidden="true"></i>
            <p class="text-sm font-normal text-900 m-0">
                {{ experience.rating | number: '1.1-1' }} ({{ experience.reviewCount | number }})
            </p>
        </div>
        <h5 class="mt-0 mb-2 overflow-hidden" [title]="experience.title" style="display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical">{{ experience.title }}</h5>
    </ng-template>

    <ng-template pTemplate="content">
        <div *ngIf="experience.badge as badge" class="mb-2">
            <span class="badge bg-info mr-1 flex align-items-center gap-1 text-900">
                <i [class]="badgeDisplays[badge].icon" aria-hidden="true"></i>
                {{ badgeDisplays[badge].label }}
            </span>
        </div>
        <div *ngIf="experience.duration" class="mb-2 flex align-items-center gap-1">
            <i class="ph ph-clock" aria-hidden="true"></i>
            <span class="text-900">{{ experience.duration | experienceDuration }}</span>
        </div>
        <div *ngIf="experience.hasFreeCancellation" class="mb-2 flex align-items-center gap-1">
            <i class="ph ph-shield-check" aria-hidden="true"></i>
            <span class="text-900">Free cancellation</span>
        </div>
        <ng-container *ngIf="hasMemberPricing; else regularPrice">
            <div *ngIf="showDiscountPill; else strikethroughPrice" class="mt-auto flex flex-wrap align-items-center justify-content-between gap-2">
                <span class="flex align-items-baseline gap-2">
                    <span class="text-600">From</span>
                    <span class="text-2xl font-bold text-900">{{ experience.memberPriceUsd | currency: 'USD' }}</span>
                </span>
                <p-tag value="8% off" [rounded]="true" styleClass="bg-primary-50 text-primary-700 white-space-nowrap text-base px-3 py-2"></p-tag>
            </div>
            <ng-template #strikethroughPrice>
                <div class="mt-auto flex flex-wrap align-items-baseline gap-2 text-900">
                    <span>From</span>
                    <span class="text-xl font-bold text-primary">{{ experience.memberPriceUsd | currency: 'USD' }}</span>
                    <span class="text-500 line-through">{{ experience.fromPriceUsd | currency: 'USD' }}</span>
                </div>
            </ng-template>
        </ng-container>
        <ng-template #regularPrice>
            <div class="mt-auto flex flex-column gap-1 text-900">
                <span>From <span class="text-xl font-bold">{{ experience.fromPriceUsd | currency: 'USD' }}</span></span>
                <span class="text-sm font-semibold text-primary">
                    {{ experience.memberPriceUsd | currency: 'USD' }} <span class="text-900">with Premium<span class="text-primary">+</span></span>
                </span>
            </div>
        </ng-template>
    </ng-template>
</p-card>
